import { render, staticRenderFns } from "./JianKang_usermana.vue?vue&type=template&id=10ce932f&scoped=true"
import script from "./JianKang_usermana.vue?vue&type=script&lang=js"
export * from "./JianKang_usermana.vue?vue&type=script&lang=js"
import style0 from "./JianKang_usermana.vue?vue&type=style&index=0&id=10ce932f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce932f",
  null
  
)

export default component.exports